import { defaultHttpClient } from './_HttpClient';
import { CouponShowCaseModel } from '../types/Coupon';
export async function GetCouponShowCase(type) {
    const response = await defaultHttpClient.post('/ajax/coupon.aspx/GetCouponShowCase', { type: type });
    const data = response.data;
    const list = data.d.Data;
    const infos = list.map((p) => {
        return { ...new CouponShowCaseModel(), ...p };
    });
    return infos || [];
}
export async function GetCustomerMVPInfo() {
    const response = await defaultHttpClient.post('/ajax/customer.aspx/GetCustomerMVPInfo', {});
    const data = response.data;
    const info = data.d.Data;
    return info || {};
}
/**
 * 获取coupon clipped
 * @returns
 */
export async function GetClippedCoupon() {
    const response = await defaultHttpClient.post('/Ajax/customer.aspx/GetCouponClipped', {});
    const data = response.data;
    const info = data.d;
    return info;
}
export async function GetClippedCouponList(pageIndex) {
    const resp = await defaultHttpClient.post('/Ajax/Coupon.aspx/GetClippedCouponList', { pageIndex: pageIndex });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function DeleteClippedCoupon(sysNo) {
    const resp = await defaultHttpClient.post('/Ajax/Coupon.aspx/DeleteClippedCoupon', { sysNo: sysNo });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function ClipCouponCode(couponCodeSysNo) {
    const resp = await defaultHttpClient.post('/Ajax/Coupon.aspx/ClipCouponCode', { couponCodeSysNo: couponCodeSysNo });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function CopyCode(couponCodeSysNo) {
    const resp = await defaultHttpClient.post('/Ajax/Customer.aspx/CopyCode', { codeSysNo: couponCodeSysNo });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function CopyCouponCode(couponCode) {
    const resp = await defaultHttpClient.post('/Ajax/Customer.aspx/CopyCouponCode', { couponCode: couponCode });
    const data = resp.data;
    return JSON.parse(data.d);
}
